// Sweet Alerts
import Swal from 'sweetalert2'

export default class Alert {

    static success(message, config = {}, callback = null) {
        Swal.fire({
            ...{
                icon: 'success',
                html: message
            },
            ...config
        })
            .then(result => {
                if (callback) {
                    callback()
                }
            })
    }

    static error(message, config = {}, callback = null) {
        Swal.fire({
            ...{
                icon: 'error',
                html: message
            },
            ...config
        })
            .then(result => {
                console.log(result)
                if (callback) {
                    callback()
                }
            })
    }

    static danger(message) {
        Swal.fire({
            icon: 'error',
            html: message
        })
    }

    static warning(message, config = {}) {
        Swal.fire({
            ... {
                icon: 'warning',
                html: message
            },
            ... config
        })
    }

    static info(message) {
        Swal.fire({
            icon: 'info',
            html: message
        })
    }
}
